// extracted by mini-css-extract-plugin
export default {"zoomModal":"F3-z","image":"G3-z","button":"H3-z","isOverlayShown":"I3-z"};